'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pubsub = require('../events/pubsub.js');
var index = require('../events/index.js');
var id = require('../util/id.js');
var session = require('../session/session.js');

(function(WS_STATUS2) {
  WS_STATUS2[WS_STATUS2["CONNECTING"] = 0] = "CONNECTING";
  WS_STATUS2[WS_STATUS2["CONNECTED"] = 1] = "CONNECTED";
  WS_STATUS2[WS_STATUS2["DISCONNECTING"] = 2] = "DISCONNECTING";
  WS_STATUS2[WS_STATUS2["DISCONNECTED"] = 3] = "DISCONNECTED";
})(exports.WS_STATUS || (exports.WS_STATUS = {}));
class WS {
  constructor(url, key, isDesktopDevice, driver) {
    this.url = url;
    this.key = key;
    this.isDesktopDevice = isDesktopDevice;
    this.driver = driver;
    this.pendingRequests = new Map();
  }
  connect() {
    return new Promise((resolve, reject) => {
      let open = false;
      this.conn = this.initConn();
      let intervalId;
      this.conn.onopen = () => {
        open = true;
        pubsub.pubsub.publish(pubsub.Topic.WSOpen, null);
        intervalId = setInterval(() => this.request("/system/ping"), 45e3);
        if (intervalId.unref) {
          intervalId.unref();
        }
        resolve();
      };
      this.conn.onclose = (ev) => {
        clearInterval(intervalId);
        pubsub.pubsub.publish(pubsub.Topic.WSClose, ev);
      };
      this.conn.onerror = (ev) => {
        clearInterval(intervalId);
        if (!open) {
          return reject(ev);
        }
        pubsub.pubsub.publish(pubsub.Topic.WSError, ev);
      };
      this.conn.onmessage = (e) => this.onMessage(e);
    });
  }
  request(path, params) {
    if (!this.conn) {
      return Promise.reject();
    }
    const id$1 = id.generateId();
    const promise = new Promise((resolve, reject) => {
      this.pendingRequests.set(id$1, { resolve, reject });
    });
    const msg = JSON.stringify({
      id: id$1,
      path,
      payload: params
    });
    this.conn.send(msg);
    return promise;
  }
  onMessage(event) {
    const msg = JSON.parse(event.data);
    const pending = this.pendingRequests.get(msg.id);
    if (pending) {
      msg.error ? pending.reject(msg.error) : pending.resolve(msg.payload);
      this.pendingRequests.delete(msg.id);
      return;
    }
    if (msg.topic) {
      index.events.distribute(msg.topic, msg.payload);
      return;
    }
  }
  initConn() {
    if (this.conn) {
      this.conn.close();
    }
    let url = `${this.url}/v2?key=${this.key}&isDesktopDevice=${this.isDesktopDevice}`;
    const sid = session.session.getId();
    if (sid) {
      url += `&sid=${sid}`;
    }
    if (this.driver) {
      return new this.driver(url);
    }
    return new WebSocket(url);
  }
}

exports.WS = WS;
